<script setup>
import { Primitive } from 'radix-vue';
import { buttonVariants } from '.';
import { cn } from '@/lib/utils';

const props = defineProps({
  variant: { type: null, required: false },
  size: { type: null, required: false },
  class: { type: null, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false, default: 'button' },
});
</script>

<template>
  <Primitive
    :as="as"
    :as-child="asChild"
    :class="cn(buttonVariants({ variant, size }), props.class, 'hover:scale-105 transition-all duration-300')"
  >
    <slot />
  </Primitive>
</template>
